// import React, { useState, useMemo, useEffect } from 'react';
// import { formatCurrency, formatTokenBalance, isEmpty, isEthereumAddress } from '../utils';
// import useSWR from 'swr';
// import endpoint from '../Api/endpoint';
// import Loader from './Loader';
// import { Copy } from 'lucide-react';
// import { toast } from 'sonner';

// // Helper functions for token avatars
// const getTokenAvatar = (code) => {
//   if (!code) return '?';
//   return code.charAt(0).toUpperCase();
// };

// const getAvatarColor = (code) => {
//   if (!code) return 'bg-gray-400';
//   const colors = [
//     'bg-blue-500', 'bg-purple-500', 'bg-green-500', 'bg-yellow-500',
//     'bg-red-500', 'bg-indigo-500', 'bg-pink-500', 'bg-teal-500'
//   ];
//   const index = code.charCodeAt(0) % colors.length;
//   return colors[index];
// };

// const shortenString = (str, length = 10) => {
//   if (!str) return '';
//   return `${str?.slice(0, length)}...${str?.slice(-length)}`;
// }



// function CoingSelectorItem({ coin, onClick }) {

//   const [copied, setCopied] = useState(false);

//   const handleCopy = () => {
//     if (coin?.address) {
//       navigator.clipboard.writeText(coin.address);
//       setCopied(true);
//     // toast.success('Copied!');
//     toast.info('Copied!');

//       setTimeout(() => setCopied(false), 1500); // reset after 1.5s
//     }
//   };
//   return (
//     <div
//       onClick={() => onClick(coin)}
//       className="group flex items-center justify-between p-4 cursor-pointer select-none hover:bg-gradient-to-r hover:from-gray-50 hover:to-purple-50 transition-all duration-200 border-b border-gray-100 last:border-b-0"
//     >
//       <div className="flex items-center space-x-3 flex-1 min-w-0">
//         {/* Token Avatar */}
//         <div className={`w-10 h-10 rounded-full ${getAvatarColor(coin?.code)} flex items-center justify-center text-white font-bold text-sm shadow-sm`}>
//           {getTokenAvatar(coin?.code)}
//         </div>

//         <div className="flex flex-col items-start justify-center min-w-0 flex-1">
//           <div className="flex items-center space-x-[5px] mb-0.5">
//             <div className="font-semibold text-base text-gray-900 uppercase group-hover:text-purple-700 transition-colors">
//               {coin?.code || '--'}
//             </div>
//             {coin?.verified && (
//               <div className="relative group/badge">
//                 <div className="bg-[#12b981]/10 rounded-full pl-[3px] py-[0.5px] pr-[5px] flex items-center" title="Verified Token">
//                   <svg className="!size-[15px] shrink-0 text-[#12b981] drop-shadow-sm" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
//                     <path d="m9 12.14 2.007 2.005a12.84 12.84 0 0 1 3.906-4.23l.087-.06M21.25 12c0-1.29-.794-2.41-1.976-3.014.415-1.255.18-2.617-.731-3.529-.912-.911-2.274-1.146-3.529-.73C14.42 3.543 13.291 2.75 12 2.75s-2.41.794-3.005 1.976c-1.264-.415-2.626-.18-3.538.731-.911.912-1.137 2.274-.722 3.529C3.553 9.59 2.75 10.709 2.75 12s.803 2.41 1.985 3.014c-.415 1.255-.19 2.617.722 3.529s2.274 1.137 3.529.73C9.59 20.457 10.709 21.25 12 21.25s2.419-.794 3.014-1.976c1.255.406 2.617.18 3.529-.731.911-.912 1.146-2.274.73-3.529 1.183-.604 1.977-1.723 1.977-3.014Z" fill="none" />
//                   </svg>
//                   {/* <span className="text-[#12b981] text-[12px]">Verified</span> */}
//                 </div>
//               </div>
//             )}
//           </div>
//           <div className="text-sm text-gray-500 flex items-center space-x-[5px] justify-start truncate group-hover:text-gray-600 transition-colors">
//             <span>{coin?.name || 'Unknown Token'}</span>
//             <span className="text-gray-500">{shortenString(coin?.address, 7)}</span>
//             <button
//               onClick={(e) => {
//                 e.stopPropagation(); // 👈 prevents parent onClick from firing
//                 handleCopy();
//               }}
//               className="hover:text-gray-700 transition-colors"
//               title={copied ? "Copied!" : "Copy address"}
//             >
//               <Copy size={14} />
//             </button>
//           </div>
//         </div>
//       </div>

//       {coin?.balance > 0.00001 && (
//         <div className="flex flex-col justify-end text-right ml-3 whitespace-nowrap">
//           <span className="font-semibold text-gray-900 text-sm">
//             {formatTokenBalance(coin.balance)}
//           </span>
//           <span className="text-xs text-gray-500 mt-0.5">
//             {formatCurrency(coin.balance_usd)}
//           </span>
//         </div>
//       )}
//     </div>
//   );
// }

// const CoinSelector = ({
//   isOpen,
//   onClose,
//   onSelectCoin,
//   tokens = []
// }) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [externalToken, setExternalToken] = useState(null);
//   const [shouldSearchExternal, setShouldSearchExternal] = useState(false);

//   const { isLoading, data } = useSWR(
//     shouldSearchExternal && externalToken ?
//       `${endpoint.token}/${externalToken}` :
//       null
//   );

//   // Reset external search when search term changes
//   useEffect(() => {
//     if (searchTerm !== externalToken) {
//       setExternalToken(null);
//       setShouldSearchExternal(false);
//     }
//   }, [searchTerm, externalToken]);

//   // Get featured tokens (limit to 4)
//   const featuredTokens = useMemo(() => {
//     return tokens.filter(token => token.featured === true).slice(0, 4);
//   }, [tokens]);

//   // Filter tokens on-the-fly based on search term
//   const filteredTokens = useMemo(() => {
//     if (!searchTerm.trim()) {
//       return tokens;
//     }

//     const term = searchTerm.toLowerCase().trim();
//     const result = tokens.filter(token =>
//       token.code?.toLowerCase().includes(term) ||
//       token.name?.toLowerCase().includes(term) ||
//       token.address?.toLowerCase().includes(term)
//     );

//     // Only trigger external search if no local results and valid address
//     if (isEmpty(result) && isEthereumAddress(term) && !shouldSearchExternal) {
//       setExternalToken(term);
//       setShouldSearchExternal(true);
//     }

//     return result;
//   }, [searchTerm, tokens, shouldSearchExternal]);

//   if (!isOpen) return null;

//   const handleOverlayClick = (e) => {
//     if (e.target === e.currentTarget) onClose();
//   };

//   const handleOnSelect = (coin) => {
//     onSelectCoin(coin);
//     onClose();
//   }



//   return (
//     <div
//       onClick={handleOverlayClick}
//       className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4 animate-in fade-in duration-200"
//     >
//       <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md h-[700px] sm:h-[80%] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200 border border-gray-200">
//         {/* Header */}
//         <div className="p-6 border-b border-gray-100 bg-white">
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-xl font-bold text-gray-900">Select Token</h2>
//             <button
//               onClick={onClose}
//               aria-label="Close"
//               className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 hover:text-gray-700 transition-all duration-200 hover:scale-105"
//             >
//               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </button>
//           </div>

//           {/* Search Input */}
//           <div className="relative">
//             <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//               <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//               </svg>
//             </div>
//             <input
//               type="text"
//               placeholder="Search by name, symbol, or address..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full pl-10 pr-4 py-3 text-base rounded-xl border border-gray-200 focus:outline-none focus:ring-1 focus:ring-purple-500/20 focus:border-purple-400 transition-all duration-200 bg-white placeholder-gray-400"
//               autoFocus
//             />
//             {searchTerm && (
//               <button
//                 onClick={() => setSearchTerm('')}
//                 className="absolute inset-y-0 right-0 pr-3 flex items-center"
//               >
//                 <svg className="h-4 w-4 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Featured Tokens Section */}
//         {!searchTerm.trim() && featuredTokens.length > 0 && (
//           <div className="border-b border-gray-100 bg-[#a855f7]/5 px-6 py-4">
//             <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
//               <svg className="w-4 h-4 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
//               </svg>
//               Featured Tokens
//             </h3>
//             <div className="grid grid-cols-2 gap-2">
//               {featuredTokens.map((coin, i) => (
//                 <div
//                   key={coin?.address || i}
//                   onClick={() => handleOnSelect(coin)}
//                   className="group flex items-center p-3 cursor-pointer select-none hover:bg-white/70 transition-all duration-200 rounded-lg bg-white/100 backdrop-blur-sm"
//                 >
//                   <div className={`w-8 h-8 rounded-full ${getAvatarColor(coin?.code)} flex items-center justify-center text-white font-bold text-xs shadow-sm mr-3`}>
//                     {getTokenAvatar(coin?.code)}
//                   </div>
//                   <div className="flex flex-col items-start justify-center min-w-0 flex-1">
//                     <div className="flex items-center space-x-1 mb-0.5">
//                       <div className="font-semibold text-sm text-gray-900 uppercase group-hover:text-purple-700 transition-colors">
//                         {coin?.code || '--'}
//                       </div>
//                       {coin?.verified && (
//                         <svg className="!size-[15px] shrink-0 text-green-500" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
//                           <path d="m9 12.14 2.007 2.005a12.84 12.84 0 0 1 3.906-4.23l.087-.06M21.25 12c0-1.29-.794-2.41-1.976-3.014.415-1.255.18-2.617-.731-3.529-.912-.911-2.274-1.146-3.529-.73C14.42 3.543 13.291 2.75 12 2.75s-2.41.794-3.005 1.976c-1.264-.415-2.626-.18-3.538.731-.911.912-1.137 2.274-.722 3.529C3.553 9.59 2.75 10.709 2.75 12s.803 2.41 1.985 3.014c-.415 1.255-.19 2.617.722 3.529s2.274 1.137 3.529.73C9.59 20.457 10.709 21.25 12 21.25s2.419-.794 3.014-1.976c1.255.406 2.617.18 3.529-.731.911-.912 1.146-2.274.73-3.529 1.183-.604 1.977-1.723 1.977-3.014Z" fill="none" />
//                         </svg>
//                       )}
//                     </div>
//                     <div className="text-xs text-gray-600 truncate max-w-[100px]">
//                       {coin?.name || 'Unknown'}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Token List */}
//         <div className="overflow-y-auto flex-1 bg-white">
//           {isLoading ? (
//             <div className="flex flex-col items-center justify-center h-full space-y-3 text-gray-500">
//               <Loader />
//               <span className="text-sm font-medium">Searching for token...</span>
//             </div>
//           ) : (filteredTokens.length === 0 && !data?.data) ? (
//             <div className="flex flex-col items-center justify-center h-full space-y-3 text-gray-500">
//               <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
//                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.29-1.009-5.824-2.563M15 9.34c-1.44-1.122-3.248-1.34-5.172-1.34-1.925 0-3.733.218-5.173 1.34M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//               </div>
//               <div className="text-center">
//                 <p className="font-medium text-gray-900">
//                   {searchTerm.trim() ? 'No tokens found' : 'No tokens available'}
//                 </p>
//                 <p className="text-sm text-gray-500 mt-1">
//                   {searchTerm.trim()
//                     ? 'Try searching with a different term or token address'
//                     : 'Connect your wallet to see available tokens'
//                   }
//                 </p>
//               </div>
//             </div>
//           ) : !isEmpty(data?.data) ? (
//             <CoingSelectorItem
//               coin={data?.data}
//               onClick={handleOnSelect}
//             />
//           ) : (
//             <div className="divide-y divide-gray-100">
//               {filteredTokens.map((coin, i) => (
//                 <CoingSelectorItem
//                   key={coin?.address || i}
//                   coin={coin}
//                   onClick={handleOnSelect}
//                 />
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CoinSelector;

































// "use client"

// import { useState, useMemo, useEffect } from "react"
// import { formatCurrency, formatTokenBalance, isEmpty, isEthereumAddress } from "../utils"
// import useSWR from "swr"
// import endpoint from "../Api/endpoint"
// import Loader from "./Loader"

// // Helper functions for token avatars
// const getTokenAvatar = (code) => {
//   if (!code) return "?"
//   return code.charAt(0).toUpperCase()
// }

// const getAvatarColor = (code) => {
//   if (!code) return "bg-gray-400"
//   const colors = [
//     "bg-blue-500",
//     "bg-purple-500",
//     "bg-green-500",
//     "bg-yellow-500",
//     "bg-red-500",
//     "bg-indigo-500",
//     "bg-pink-500",
//     "bg-teal-500",
//   ]
//   const index = code.charCodeAt(0) % colors.length
//   return colors[index]
// }

// const shortenString = (str, length = 10) => {
//   if (!str) return ""
//   return `${str?.slice(0, length)}...${str?.slice(-length)}`
// }

// const TokenIcon = ({ coin, size = "md" }) => {
//   const [imageError, setImageError] = useState(false)
//   const [imageLoaded, setImageLoaded] = useState(false)

//   const sizeClasses = {
//     sm: "w-8 h-8 text-xs",
//     md: "w-10 h-10 text-sm",
//     lg: "w-12 h-12 text-base",
//   }

//   const sizeClass = sizeClasses[size] || sizeClasses.md

//   // Show avatar if no icon URL or image failed to load
//   if (!coin?.icon || imageError) {
//     return (
//       <div
//         className={`${sizeClass} rounded-full ${getAvatarColor(coin?.code)} flex items-center justify-center text-white font-bold shadow-sm`}
//       >
//         {getTokenAvatar(coin?.code)}
//       </div>
//     )
//   }

//   return (
//     <div
//       className={`${sizeClass} rounded-full bg-white flex items-center justify-center shadow-sm overflow-hidden relative`}
//     >
//       {!imageLoaded && (
//         <div
//           className={`absolute inset-0 ${getAvatarColor(coin?.code)} flex items-center justify-center text-white font-bold`}
//         >
//           {getTokenAvatar(coin?.code)}
//         </div>
//       )}
//       <img
//         src={coin.icon || "/placeholder.svg"}
//         alt={coin?.code || "Token"}
//         className={`w-full h-full object-cover transition-opacity duration-200 ${imageLoaded ? "opacity-100" : "opacity-0"}`}
//         onLoad={() => setImageLoaded(true)}
//         onError={() => setImageError(true)}
//       />
//     </div>
//   )
// }

// function CoingSelectorItem({ coin, onClick }) {
//   return (
//     <div
//       onClick={() => onClick(coin)}
//       className="group flex items-center justify-between p-4 cursor-pointer select-none hover:bg-gradient-to-r hover:from-gray-50 hover:to-purple-50 transition-all duration-200 border-b border-gray-100 last:border-b-0"
//     >
//       <div className="flex items-center space-x-3 flex-1 min-w-0">
//         <TokenIcon coin={coin} size="md" />

//         <div className="flex flex-col items-start justify-center min-w-0 flex-1">
//           <div className="flex items-center space-x-[5px] mb-0.5">
//             <div className="font-semibold text-base text-gray-900 uppercase group-hover:text-purple-700 transition-colors">
//               {coin?.code || "--"}
//             </div>
//             {coin?.verified && (
//               <div className="relative group/badge">
//                 <div
//                   className="bg-[#12b981]/10 rounded-full pl-[3px] py-[0.5px] pr-[5px] flex items-center"
//                   title="Verified Token"
//                 >
//                   <svg
//                     className="!size-[15px] shrink-0 text-[#12b981] drop-shadow-sm"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       d="m9 12.14 2.007 2.005a12.84 12.84 0 0 1 3.906-4.23l.087-.06M21.25 12c0-1.29-.794-2.41-1.976-3.014.415-1.255.18-2.617-.731-3.529-.912-.911-2.274-1.146-3.529-.73C14.42 3.543 13.291 2.75 12 2.75s-2.41.794-3.005 1.976c-1.264-.415-2.626-.18-3.538.731-.911.912-1.137 2.274-.722 3.529C3.553 9.59 2.75 10.709 2.75 12s.803 2.41 1.985 3.014c-.415 1.255-.19 2.617.722 3.529s2.274 1.137 3.529.73C9.59 20.457 10.709 21.25 12 21.25s2.419-.794 3.014-1.976c1.255.406 2.617.18 3.529-.731.911-.912 1.146-2.274.73-3.529 1.183-.604 1.977-1.723 1.977-3.014Z"
//                       fill="none"
//                     />
//                   </svg>
//                   <span className="text-[#12b981] text-[12px]">Verified</span>
//                 </div>
//               </div>
//             )}
//           </div>
//           <div className="text-sm text-gray-500 flex items-center space-x-[5px] justify-start truncate group-hover:text-gray-600 transition-colors">
//             <span>{coin?.name || "Unknown Token"}</span>
//             <span className="text-gray-500">{shortenString(coin?.address, 7)}</span>
//           </div>
//         </div>
//       </div>

//       {coin?.balance > 0.00001 && (
//         <div className="flex flex-col justify-end text-right ml-3 whitespace-nowrap">
//           <span className="font-semibold text-gray-900 text-sm">{formatTokenBalance(coin.balance)}</span>
//           <span className="text-xs text-gray-500 mt-0.5">{formatCurrency(coin.balance_usd)}</span>
//         </div>
//       )}
//     </div>
//   )
// }

// const CoinSelector = ({ isOpen, onClose, onSelectCoin, tokens = [] }) => {
//   const [searchTerm, setSearchTerm] = useState("")
//   const [externalToken, setExternalToken] = useState(null)
//   const [shouldSearchExternal, setShouldSearchExternal] = useState(false)

//   const { isLoading, data } = useSWR(
//     shouldSearchExternal && externalToken ? `${endpoint.token}/${externalToken}` : null,
//   )

//   // Reset external search when search term changes
//   useEffect(() => {
//     if (searchTerm !== externalToken) {
//       setExternalToken(null)
//       setShouldSearchExternal(false)
//     }
//   }, [searchTerm, externalToken])

//   // Get featured tokens (limit to 4)
//   const featuredTokens = useMemo(() => {
//     return tokens.filter((token) => token.featured === true).slice(0, 4)
//   }, [tokens])

//   // Filter tokens on-the-fly based on search term
//   const filteredTokens = useMemo(() => {
//     if (!searchTerm.trim()) {
//       return tokens
//     }

//     const term = searchTerm.toLowerCase().trim()
//     const result = tokens.filter(
//       (token) =>
//         token.code?.toLowerCase().includes(term) ||
//         token.name?.toLowerCase().includes(term) ||
//         token.address?.toLowerCase().includes(term),
//     )

//     // Only trigger external search if no local results and valid address
//     if (isEmpty(result) && isEthereumAddress(term) && !shouldSearchExternal) {
//       setExternalToken(term)
//       setShouldSearchExternal(true)
//     }

//     return result
//   }, [searchTerm, tokens, shouldSearchExternal])

//   if (!isOpen) return null

//   const handleOverlayClick = (e) => {
//     if (e.target === e.currentTarget) onClose()
//   }

//   const handleOnSelect = (coin) => {
//     onSelectCoin(coin)
//     onClose()
//   }

//   return (
//     <div
//       onClick={handleOverlayClick}
//       className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4 animate-in fade-in duration-200"
//     >
//       <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md h-[700px] sm:h-[80%] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200 border border-gray-200">
//         {/* Header */}
//         <div className="p-6 border-b border-gray-100 bg-white">
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-xl font-bold text-gray-900">Select Token</h2>
//             <button
//               onClick={onClose}
//               aria-label="Close"
//               className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 hover:text-gray-700 transition-all duration-200 hover:scale-105"
//             >
//               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </button>
//           </div>

//           {/* Search Input */}
//           <div className="relative">
//             <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//               <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                 />
//               </svg>
//             </div>
//             <input
//               type="text"
//               placeholder="Search by name, symbol, or address..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full pl-10 pr-4 py-3 text-base rounded-xl border border-gray-200 focus:outline-none focus:ring-1 focus:ring-purple-500/20 focus:border-purple-400 transition-all duration-200 bg-white placeholder-gray-400"
//               autoFocus
//             />
//             {searchTerm && (
//               <button onClick={() => setSearchTerm("")} className="absolute inset-y-0 right-0 pr-3 flex items-center">
//                 <svg
//                   className="h-4 w-4 text-gray-400 hover:text-gray-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Featured Tokens Section */}
//         {!searchTerm.trim() && featuredTokens.length > 0 && (
//           <div className="border-b border-gray-100 bg-[#a855f7]/5 px-6 py-4">
//             <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
//               <svg className="w-4 h-4 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
//                 />
//               </svg>
//               Featured Tokens
//             </h3>
//             <div className="grid grid-cols-2 gap-2">
//               {featuredTokens.map((coin, i) => (
//                 <div
//                   key={coin?.address || i}
//                   onClick={() => handleOnSelect(coin)}
//                   className="group flex items-center p-3 cursor-pointer select-none hover:bg-white/70 transition-all duration-200 rounded-lg bg-white/100 backdrop-blur-sm"
//                 >
//                   <TokenIcon coin={coin} size="sm" />
//                   <div className="flex flex-col items-start justify-center min-w-0 flex-1 ml-3">
//                     <div className="flex items-center space-x-1 mb-0.5">
//                       <div className="font-semibold text-sm text-gray-900 uppercase group-hover:text-purple-700 transition-colors">
//                         {coin?.code || "--"}
//                       </div>
//                       {coin?.verified && (
//                         <svg
//                           className="!size-[15px] shrink-0 text-green-500"
//                           fill="none"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             d="m9 12.14 2.007 2.005a12.84 12.84 0 0 1 3.906-4.23l.087-.06M21.25 12c0-1.29-.794-2.41-1.976-3.014.415-1.255.18-2.617-.731-3.529-.912-.911-2.274-1.146-3.529-.73C14.42 3.543 13.291 2.75 12 2.75s-2.41.794-3.005 1.976c-1.264-.415-2.626-.18-3.538.731-.911.912-1.137 2.274-.722 3.529C3.553 9.59 2.75 10.709 2.75 12s.803 2.41 1.985 3.014c-.415 1.255-.19 2.617.722 3.529s2.274 1.137 3.529.73C9.59 20.457 10.709 21.25 12 21.25s2.419-.794 3.014-1.976c1.255.406 2.617.18 3.529-.731.911-.912 1.146-2.274.73-3.529 1.183-.604 1.977-1.723 1.977-3.014Z"
//                             fill="none"
//                           />
//                         </svg>
//                       )}
//                     </div>
//                     <div className="text-xs text-gray-600 truncate max-w-[100px]">{coin?.name || "Unknown"}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Token List */}
//         <div className="overflow-y-auto flex-1 bg-white">
//           {isLoading ? (
//             <div className="flex flex-col items-center justify-center h-full space-y-3 text-gray-500">
//               <Loader />
//               <span className="text-sm font-medium">Searching for token...</span>
//             </div>
//           ) : filteredTokens.length === 0 && !data?.data ? (
//             <div className="flex flex-col items-center justify-center h-full space-y-3 text-gray-500">
//               <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
//                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.29-1.009-5.824-2.563M15 9.34c-1.44-1.122-3.248-1.34-5.172-1.34-1.925 0-3.733.218-5.173 1.34M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//               </div>
//               <div className="text-center">
//                 <p className="font-medium text-gray-900">
//                   {searchTerm.trim() ? "No tokens found" : "No tokens available"}
//                 </p>
//                 <p className="text-sm text-gray-500 mt-1">
//                   {searchTerm.trim()
//                     ? "Try searching with a different term or token address"
//                     : "Connect your wallet to see available tokens"}
//                 </p>
//               </div>
//             </div>
//           ) : !isEmpty(data?.data) ? (
//             <CoingSelectorItem coin={data?.data} onClick={handleOnSelect} />
//           ) : (
//             <div className="divide-y divide-gray-100">
//               {filteredTokens.map((coin, i) => (
//                 <CoingSelectorItem key={coin?.address || i} coin={coin} onClick={handleOnSelect} />
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   )
// }

// export default CoinSelector























// "use client"

// import { useState, useMemo, useEffect } from "react"
// import { formatCurrency, formatTokenBalance, isEmpty, isEthereumAddress } from "../utils"
// import useSWR from "swr"
// import endpoint from "../Api/endpoint"
// import Loader from "./Loader"
// import { getTokenIcon, fetchTokenIcon, preloadTokenIcons } from "../utils/tokenIcons"

// // Helper functions for token avatars
// const getTokenAvatar = (code) => {
//   if (!code) return "?"
//   return code.charAt(0).toUpperCase()
// }

// const getAvatarColor = (code) => {
//   if (!code) return "bg-gray-400"
//   const colors = [
//     "bg-blue-500",
//     "bg-purple-500",
//     "bg-green-500",
//     "bg-yellow-500",
//     "bg-red-500",
//     "bg-indigo-500",
//     "bg-pink-500",
//     "bg-teal-500",
//   ]
//   const index = code.charCodeAt(0) % colors.length
//   return colors[index]
// }

// const shortenString = (str, length = 10) => {
//   if (!str) return ""
//   return `${str?.slice(0, length)}...${str?.slice(-length)}`
// }

// const TokenIcon = ({ coin, size = "md" }) => {
//   const [imageError, setImageError] = useState(false)
//   const [imageLoaded, setImageLoaded] = useState(false)
//   const [dynamicIcon, setDynamicIcon] = useState(null)

//   const sizeClasses = {
//     sm: "w-8 h-8 text-xs",
//     md: "w-10 h-10 text-sm",
//     lg: "w-12 h-12 text-base",
//   }

//   const sizeClass = sizeClasses[size] || sizeClasses.md

//   useEffect(() => {
//     const loadIcon = async () => {
//       if (!coin?.address) return

//       if (coin?.icon) return

//       try {
//         const fetchedIcon = await fetchTokenIcon(coin.address)
//         setDynamicIcon(fetchedIcon)
//       } catch (error) {
//         console.error("[v0] Failed to fetch token icon:", error)
//       }
//     }

//     loadIcon()
//   }, [coin?.address, coin?.icon])

//   const iconUrl = dynamicIcon || getTokenIcon(coin?.address, coin?.icon)

//   if (!iconUrl || iconUrl === "/placeholder.svg" || imageError) {
//     return (
//       <div
//         className={`${sizeClass} rounded-full ${getAvatarColor(coin?.code)} flex items-center justify-center text-white font-bold shadow-sm`}
//       >
//         {getTokenAvatar(coin?.code)}
//       </div>
//     )
//   }

//   return (
//     <div
//       className={`${sizeClass} rounded-full bg-white flex items-center justify-center shadow-sm overflow-hidden relative`}
//     >
//       {!imageLoaded && (
//         <div
//           className={`absolute inset-0 ${getAvatarColor(coin?.code)} flex items-center justify-center text-white font-bold`}
//         >
//           {getTokenAvatar(coin?.code)}
//         </div>
//       )}
//       <img
//         src={iconUrl || "/placeholder.svg"}
//         alt={coin?.code || "Token"}
//         className={`w-full h-full object-cover transition-opacity duration-200 ${imageLoaded ? "opacity-100" : "opacity-0"}`}
//         onLoad={() => setImageLoaded(true)}
//         onError={() => setImageError(true)}
//       />
//     </div>
//   )
// }

// function CoingSelectorItem({ coin, onClick }) {
//   return (
//     <div
//       onClick={() => onClick(coin)}
//       className="group flex items-center justify-between p-4 cursor-pointer select-none hover:bg-gradient-to-r hover:from-gray-50 hover:to-purple-50 transition-all duration-200 border-b border-gray-100 last:border-b-0"
//     >
//       <div className="flex items-center space-x-3 flex-1 min-w-0">
//         <TokenIcon coin={coin} size="md" />

//         <div className="flex flex-col items-start justify-center min-w-0 flex-1">
//           <div className="flex items-center space-x-[5px] mb-0.5">
//             <div className="font-semibold text-base text-gray-900 uppercase group-hover:text-purple-700 transition-colors">
//               {coin?.code || "--"}
//             </div>
//             {coin?.verified && (
//               <div className="relative group/badge">
//                 <div
//                   className="bg-[#12b981]/10 rounded-full pl-[3px] py-[0.5px] pr-[5px] flex items-center"
//                   title="Verified Token"
//                 >
//                   <svg
//                     className="!size-[15px] shrink-0 text-[#12b981] drop-shadow-sm"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       d="m9 12.14 2.007 2.005a12.84 12.84 0 0 1 3.906-4.23l.087-.06M21.25 12c0-1.29-.794-2.41-1.976-3.014.415-1.255.18-2.617-.731-3.529-.912-.911-2.274-1.146-3.529-.73C14.42 3.543 13.291 2.75 12 2.75s-2.41.794-3.005 1.976c-1.264-.415-2.626-.18-3.538.731-.911.912-1.137 2.274-.722 3.529C3.553 9.59 2.75 10.709 2.75 12s.803 2.41 1.985 3.014c-.415 1.255-.19 2.617.722 3.529s2.274 1.137 3.529.73C9.59 20.457 10.709 21.25 12 21.25s2.419-.794 3.014-1.976c1.255.406 2.617.18 3.529-.731.911-.912 1.146-2.274.73-3.529 1.183-.604 1.977-1.723 1.977-3.014Z"
//                       fill="none"
//                     />
//                   </svg>
//                   <span className="text-[#12b981] text-[12px]">Verified</span>
//                 </div>
//               </div>
//             )}
//           </div>
//           <div className="text-sm text-gray-500 flex items-center space-x-[5px] justify-start truncate group-hover:text-gray-600 transition-colors">
//             <span>{coin?.name || "Unknown Token"}</span>
//             <span className="text-gray-500">{shortenString(coin?.address, 7)}</span>
//           </div>
//         </div>
//       </div>

//       {coin?.balance > 0.00001 && (
//         <div className="flex flex-col justify-end text-right ml-3 whitespace-nowrap">
//           <span className="font-semibold text-gray-900 text-sm">{formatTokenBalance(coin.balance)}</span>
//           <span className="text-xs text-gray-500 mt-0.5">{formatCurrency(coin.balance_usd)}</span>
//         </div>
//       )}
//     </div>
//   )
// }

// const CoinSelector = ({ isOpen, onClose, onSelectCoin, tokens = [] }) => {
//   const [searchTerm, setSearchTerm] = useState("")
//   const [externalToken, setExternalToken] = useState(null)
//   const [shouldSearchExternal, setShouldSearchExternal] = useState(false)

//   const { isLoading, data } = useSWR(
//     shouldSearchExternal && externalToken ? `${endpoint.token}/${externalToken}` : null,
//   )

//   useEffect(() => {
//     if (tokens && tokens.length > 0) {
//       preloadTokenIcons(tokens).catch((error) => {
//         console.error("[v0] Failed to preload token icons:", error)
//       })
//     }
//   }, [tokens])

//   useEffect(() => {
//     if (searchTerm !== externalToken) {
//       setExternalToken(null)
//       setShouldSearchExternal(false)
//     }
//   }, [searchTerm, externalToken])

//   const featuredTokens = useMemo(() => {
//     return tokens.filter((token) => token.featured === true).slice(0, 4)
//   }, [tokens])

//   const filteredTokens = useMemo(() => {
//     if (!searchTerm.trim()) {
//       return tokens
//     }

//     const term = searchTerm.toLowerCase().trim()
//     const result = tokens.filter(
//       (token) =>
//         token.code?.toLowerCase().includes(term) ||
//         token.name?.toLowerCase().includes(term) ||
//         token.address?.toLowerCase().includes(term),
//     )

//     if (isEmpty(result) && isEthereumAddress(term) && !shouldSearchExternal) {
//       setExternalToken(term)
//       setShouldSearchExternal(true)
//     }

//     return result
//   }, [searchTerm, tokens, shouldSearchExternal])

//   if (!isOpen) return null

//   const handleOverlayClick = (e) => {
//     if (e.target === e.currentTarget) onClose()
//   }

//   const handleOnSelect = (coin) => {
//     onSelectCoin(coin)
//     onClose()
//   }

//   return (
//     <div
//       onClick={handleOverlayClick}
//       className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4 animate-in fade-in duration-200"
//     >
//       <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md h-[700px] sm:h-[80%] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200 border border-gray-200">
//         {/* Header */}
//         <div className="p-6 border-b border-gray-100 bg-white">
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-xl font-bold text-gray-900">Select Token</h2>
//             <button
//               onClick={onClose}
//               aria-label="Close"
//               className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 hover:text-gray-700 transition-all duration-200 hover:scale-105"
//             >
//               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </button>
//           </div>

//           {/* Search Input */}
//           <div className="relative">
//             <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//               <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                 />
//               </svg>
//             </div>
//             <input
//               type="text"
//               placeholder="Search by name, symbol, or address..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full pl-10 pr-4 py-3 text-base rounded-xl border border-gray-200 focus:outline-none focus:ring-1 focus:ring-purple-500/20 focus:border-purple-400 transition-all duration-200 bg-white placeholder-gray-400"
//               autoFocus
//             />
//             {searchTerm && (
//               <button onClick={() => setSearchTerm("")} className="absolute inset-y-0 right-0 pr-3 flex items-center">
//                 <svg
//                   className="h-4 w-4 text-gray-400 hover:text-gray-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Featured Tokens Section */}
//         {!searchTerm.trim() && featuredTokens.length > 0 && (
//           <div className="border-b border-gray-100 bg-[#a855f7]/5 px-6 py-4">
//             <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
//               <svg className="w-4 h-4 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
//                 />
//               </svg>
//               Featured Tokens
//             </h3>
//             <div className="grid grid-cols-2 gap-2">
//               {featuredTokens.map((coin, i) => (
//                 <div
//                   key={coin?.address || i}
//                   onClick={() => handleOnSelect(coin)}
//                   className="group flex items-center p-3 cursor-pointer select-none hover:bg-white/70 transition-all duration-200 rounded-lg bg-white/100 backdrop-blur-sm"
//                 >
//                   <TokenIcon coin={coin} size="sm" />
//                   <div className="flex flex-col items-start justify-center min-w-0 flex-1 ml-3">
//                     <div className="flex items-center space-x-1 mb-0.5">
//                       <div className="font-semibold text-sm text-gray-900 uppercase group-hover:text-purple-700 transition-colors">
//                         {coin?.code || "--"}
//                       </div>
//                       {coin?.verified && (
//                         <svg
//                           className="!size-[15px] shrink-0 text-green-500"
//                           fill="none"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             d="m9 12.14 2.007 2.005a12.84 12.84 0 0 1 3.906-4.23l.087-.06M21.25 12c0-1.29-.794-2.41-1.976-3.014.415-1.255.18-2.617-.731-3.529-.912-.911-2.274-1.146-3.529-.73C14.42 3.543 13.291 2.75 12 2.75s-2.41.794-3.005 1.976c-1.264-.415-2.626-.18-3.538.731-.911.912-1.137 2.274-.722 3.529C3.553 9.59 2.75 10.709 2.75 12s.803 2.41 1.985 3.014c-.415 1.255-.19 2.617.722 3.529s2.274 1.137 3.529.73C9.59 20.457 10.709 21.25 12 21.25s2.419-.794 3.014-1.976c1.255.406 2.617.18 3.529-.731.911-.912 1.146-2.274.73-3.529 1.183-.604 1.977-1.723 1.977-3.014Z"
//                             fill="none"
//                           />
//                         </svg>
//                       )}
//                     </div>
//                     <div className="text-xs text-gray-600 truncate max-w-[100px]">{coin?.name || "Unknown"}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Token List */}
//         <div className="overflow-y-auto flex-1 bg-white">
//           {isLoading ? (
//             <div className="flex flex-col items-center justify-center h-full space-y-3 text-gray-500">
//               <Loader />
//               <span className="text-sm font-medium">Searching for token...</span>
//             </div>
//           ) : filteredTokens.length === 0 && !data?.data ? (
//             <div className="flex flex-col items-center justify-center h-full space-y-3 text-gray-500">
//               <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
//                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.29-1.009-5.824-2.563M15 9.34c-1.44-1.122-3.248-1.34-5.172-1.34-1.925 0-3.733.218-5.173 1.34M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//               </div>
//               <div className="text-center">
//                 <p className="font-medium text-gray-900">
//                   {searchTerm.trim() ? "No tokens found" : "No tokens available"}
//                 </p>
//                 <p className="text-sm text-gray-500 mt-1">
//                   {searchTerm.trim()
//                     ? "Try searching with a different term or token address"
//                     : "Connect your wallet to see available tokens"}
//                 </p>
//               </div>
//             </div>
//           ) : !isEmpty(data?.data) ? (
//             <CoingSelectorItem coin={data?.data} onClick={handleOnSelect} />
//           ) : (
//             <div className="divide-y divide-gray-100">
//               {filteredTokens.map((coin, i) => (
//                 <CoingSelectorItem key={coin?.address || i} coin={coin} onClick={handleOnSelect} />
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   )
// }

// export default CoinSelector













"use client"

import { useState, useMemo, useEffect } from "react"
import { formatCurrency, formatTokenBalance, isEmpty, isEthereumAddress } from "../utils"
import useSWR from "swr"
import endpoint from "../Api/endpoint"
import Loader from "./Loader"
import { getTokenIcon, fetchTokenIcon, preloadTokenIcons } from "../utils/tokenIcons"
import { Copy } from "lucide-react"
import { toast } from 'sonner'; 


// Helper functions for token avatars
const getTokenAvatar = (code) => {
  if (!code) return "?"
  return code.charAt(0).toUpperCase()
}

const getAvatarColor = (code) => {
  if (!code) return "bg-gray-400"
  const colors = [
    "bg-blue-500",
    "bg-purple-500",
    "bg-green-500",
    "bg-yellow-500",
    "bg-red-500",
    "bg-indigo-500",
    "bg-pink-500",
    "bg-teal-500",
  ]
  const index = code.charCodeAt(0) % colors.length
  return colors[index]
}

const shortenString = (str, length = 10) => {
  if (!str) return ""
  return `${str?.slice(0, length)}...${str?.slice(-length)}`
}

const TokenIcon = ({ coin, size = "md" }) => {
  const [imageError, setImageError] = useState(false)
  const [imageLoaded, setImageLoaded] = useState(false)
  const [dynamicIcon, setDynamicIcon] = useState(null)

  const sizeClasses = {
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-12 h-12 text-base",
  }

  const sizeClass = sizeClasses[size] || sizeClasses.md

  useEffect(() => {
    const loadIcon = async () => {
      if (!coin?.address) return

      if (coin?.icon) return

      try {
        const fetchedIcon = await fetchTokenIcon(coin.address)
        setDynamicIcon(fetchedIcon)
      } catch (error) {
        console.error("[v0] Failed to fetch token icon:", error)
      }
    }

    loadIcon()
  }, [coin?.address, coin?.icon])

  const iconUrl = dynamicIcon || getTokenIcon(coin?.address, coin?.icon)

  if (!iconUrl || iconUrl === "/placeholder.svg" || imageError) {
    return (
      <div
        className={`${sizeClass} rounded-full ${getAvatarColor(coin?.code)} flex items-center justify-center text-white font-bold shadow-sm`}
      >
        {getTokenAvatar(coin?.code)}
      </div>
    )
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-white flex items-center justify-center shadow-sm overflow-hidden relative`}
    >
      {!imageLoaded && (
        <div
          className={`absolute inset-0 ${getAvatarColor(coin?.code)} flex items-center justify-center text-white font-bold`}
        >
          {getTokenAvatar(coin?.code)}
        </div>
      )}
      <img
        src={iconUrl || "/placeholder.svg"}
        alt={coin?.code || "Token"}
        className={`w-full h-full object-cover transition-opacity duration-200 ${imageLoaded ? "opacity-100" : "opacity-0"}`}
        onLoad={() => setImageLoaded(true)}
        onError={() => setImageError(true)}
      />
    </div>
  )
}

function CoingSelectorItem({ coin, onClick }) {

    const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (coin?.address) {
      navigator.clipboard.writeText(coin.address);
      setCopied(true);
    // toast.success('Copied!');
    // toast.info('Copied!');
    toast.success(<span className="text-[10px]">Copied! <br/>{coin.address}</span>);

      setTimeout(() => setCopied(false), 1500); // reset after 1.5s
    }
  };
  return (
    <div
      onClick={() => onClick(coin)}
      className="group flex items-center justify-between p-4 cursor-pointer select-none hover:bg-gradient-to-r hover:from-gray-50 hover:to-purple-50 transition-all duration-200 border-b border-gray-100 last:border-b-0"
    >
      <div className="flex items-center space-x-3 flex-1 min-w-0">
        <TokenIcon coin={coin} size="md" />

        <div className="flex flex-col items-start justify-center min-w-0 flex-1">
          <div className="flex items-center space-x-[5px] mb-0.5">
            <div className="font-semibold text-base text-gray-900 uppercase group-hover:text-purple-700 transition-colors">
              {coin?.code || "--"}
            </div>
            {coin?.verified && (
              <div className="relative group/badge">
                <div
                  className="bg-[#12b981]/10 rounded-full pl-[3px] py-[0.5px] pr-[5px] flex items-center"
                  title="Verified Token"
                >
                  <svg
                    className="!size-[15px] shrink-0 text-[#12b981] drop-shadow-sm"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m9 12.14 2.007 2.005a12.84 12.84 0 0 1 3.906-4.23l.087-.06M21.25 12c0-1.29-.794-2.41-1.976-3.014.415-1.255.18-2.617-.731-3.529-.912-.911-2.274-1.146-3.529-.73C14.42 3.543 13.291 2.75 12 2.75s-2.41.794-3.005 1.976c-1.264-.415-2.626-.18-3.538.731-.911.912-1.137 2.274-.722 3.529C3.553 9.59 2.75 10.709 2.75 12s.803 2.41 1.985 3.014c-.415 1.255-.19 2.617.722 3.529s2.274 1.137 3.529.73C9.59 20.457 10.709 21.25 12 21.25s2.419-.794 3.014-1.976c1.255.406 2.617.18 3.529-.731.911-.912 1.146-2.274.73-3.529 1.183-.604 1.977-1.723 1.977-3.014Z"
                      fill="none"
                    />
                  </svg>
                  <span className="text-[#12b981] text-[12px]">Verified</span>
                </div>
              </div>
            )}
          </div>
          <div className="text-sm text-gray-500 flex items-center space-x-[5px] justify-start truncate group-hover:text-gray-600 transition-colors">
            <span>{coin?.name || "Unknown Token"}</span>
            <span className="text-gray-500">{shortenString(coin?.address, 7)}</span>
            <button
              onClick={(e) => {
                e.stopPropagation(); // 👈 prevents parent onClick from firing
                handleCopy();
              }}
              className="hover:text-gray-700 transition-colors"
              title={copied ? "Copied!" : "Copy address"}
            >
              <Copy size={14} />
            </button>
          </div>
        </div>
      </div>

      {coin?.balance > 0.00001 && (
        <div className="flex flex-col justify-end text-right ml-3 whitespace-nowrap">
          <span className="font-semibold text-gray-900 text-sm">{formatTokenBalance(coin.balance)}</span>
          <span className="text-xs text-gray-500 mt-0.5">{formatCurrency(coin.balance_usd)}</span>
        </div>
      )}
    </div>
  )
}

const CoinSelector = ({ isOpen, onClose, onSelectCoin, tokens = [] }) => {
  const [searchTerm, setSearchTerm] = useState("")
  const [externalToken, setExternalToken] = useState(null)
  const [shouldSearchExternal, setShouldSearchExternal] = useState(false)

  const { isLoading, data } = useSWR(
    shouldSearchExternal && externalToken ? `${endpoint.token}/${externalToken}` : null,
  )

  useEffect(() => {
    if (tokens && tokens.length > 0) {
      preloadTokenIcons(tokens).catch((error) => {
        console.error("[v0] Failed to preload token icons:", error)
      })
    }
  }, [tokens])

  useEffect(() => {
    if (searchTerm !== externalToken) {
      setExternalToken(null)
      setShouldSearchExternal(false)
    }
  }, [searchTerm, externalToken])

  const featuredTokens = useMemo(() => {
    return tokens.filter((token) => token.featured === true).slice(0, 4)
  }, [tokens])

  const filteredTokens = useMemo(() => {
    if (!searchTerm.trim()) {
      return tokens
    }

    const term = searchTerm.toLowerCase().trim()
    const result = tokens.filter(
      (token) =>
        token.code?.toLowerCase().includes(term) ||
        token.name?.toLowerCase().includes(term) ||
        token.address?.toLowerCase().includes(term),
    )

    if (isEmpty(result) && isEthereumAddress(term) && !shouldSearchExternal) {
      setExternalToken(term)
      setShouldSearchExternal(true)
    }

    return result
  }, [searchTerm, tokens, shouldSearchExternal])

  if (!isOpen) return null

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose()
  }

  const handleOnSelect = (coin) => {
    onSelectCoin(coin)
    onClose()
  }

  return (
    <div
      onClick={handleOverlayClick}
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4 animate-in fade-in duration-200"
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md h-[700px] sm:h-[80%] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200 border border-gray-200">
        {/* Header */}
        <div className="p-6 border-b border-gray-100 bg-white">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-gray-900">Select Token</h2>
            <button
              onClick={onClose}
              aria-label="Close"
              className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 hover:text-gray-700 transition-all duration-200 hover:scale-105"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Search Input */}
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <input
              type="text"
              placeholder="Search by name, symbol, or address..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-3 text-base rounded-xl border border-gray-200 focus:outline-none focus:ring-1 focus:ring-purple-500/20 focus:border-purple-400 transition-all duration-200 bg-white placeholder-gray-400"
              autoFocus
            />
            {searchTerm && (
              <button onClick={() => setSearchTerm("")} className="absolute inset-y-0 right-0 pr-3 flex items-center">
                <svg
                  className="h-4 w-4 text-gray-400 hover:text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Featured Tokens Section */}
        {!searchTerm.trim() && featuredTokens.length > 0 && (
          <div className="border-b border-gray-100 bg-[#a855f7]/5 px-6 py-4">
            <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
              <svg className="w-4 h-4 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                />
              </svg>
              Featured Tokens
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {featuredTokens.map((coin, i) => (
                <div
                  key={coin?.address || i}
                  onClick={() => handleOnSelect(coin)}
                  className="group flex items-center p-3 cursor-pointer select-none hover:bg-white/70 transition-all duration-200 rounded-lg bg-white/100 backdrop-blur-sm"
                >
                  <TokenIcon coin={coin} size="sm" />
                  <div className="flex flex-col items-start justify-center min-w-0 flex-1 ml-3">
                    <div className="flex items-center space-x-1 mb-0.5">
                      <div className="font-semibold text-sm text-gray-900 uppercase group-hover:text-purple-700 transition-colors">
                        {coin?.code || "--"}
                      </div>
                      {coin?.verified && (
                        <svg
                          className="!size-[15px] shrink-0 text-green-500"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="m9 12.14 2.007 2.005a12.84 12.84 0 0 1 3.906-4.23l.087-.06M21.25 12c0-1.29-.794-2.41-1.976-3.014.415-1.255.18-2.617-.731-3.529-.912-.911-2.274-1.146-3.529-.73C14.42 3.543 13.291 2.75 12 2.75s-2.41.794-3.005 1.976c-1.264-.415-2.626-.18-3.538.731-.911.912-1.137 2.274-.722 3.529C3.553 9.59 2.75 10.709 2.75 12s.803 2.41 1.985 3.014c-.415 1.255-.19 2.617.722 3.529s2.274 1.137 3.529.73C9.59 20.457 10.709 21.25 12 21.25s2.419-.794 3.014-1.976c1.255.406 2.617.18 3.529-.731.911-.912 1.146-2.274.73-3.529 1.183-.604 1.977-1.723 1.977-3.014Z"
                            fill="none"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="text-xs text-gray-600 truncate max-w-[100px]">{coin?.name || "Unknown"}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Token List */}
        <div className="overflow-y-auto flex-1 bg-white">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center h-full space-y-3 text-gray-500">
              <Loader />
              <span className="text-sm font-medium">Searching for token...</span>
            </div>
          ) : filteredTokens.length === 0 && !data?.data ? (
            <div className="flex flex-col items-center justify-center h-full space-y-3 text-gray-500">
              <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.29-1.009-5.824-2.563M15 9.34c-1.44-1.122-3.248-1.34-5.172-1.34-1.925 0-3.733.218-5.173 1.34M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div className="text-center">
                <p className="font-medium text-gray-900">
                  {searchTerm.trim() ? "No tokens found" : "No tokens available"}
                </p>
                <p className="text-sm text-gray-500 mt-1">
                  {searchTerm.trim()
                    ? "Try searching with a different term or token address"
                    : "Connect your wallet to see available tokens"}
                </p>
              </div>
            </div>
          ) : !isEmpty(data?.data) ? (
            <CoingSelectorItem coin={data?.data} onClick={handleOnSelect} />
          ) : (
            <div className="divide-y divide-gray-100">
              {filteredTokens.map((coin, i) => (
                <CoingSelectorItem key={coin?.address || i} coin={coin} onClick={handleOnSelect} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CoinSelector
